export default {
  UPDATE_MENU: 'updateMenu',
  UPDATE_TITLE: 'updateTitle',
  UPDATE_IMAGE: 'updateImage',
  UPDATE_HAS_VALID_LICENSE: 'updateHasValidLicense',
  DESTROY_MENU: 'destroyMenu',
  DESTROY_TITLE: 'destroyTitle',
  DESTROY_IMAGE: 'destroyImage',
  DESTROY_HAS_VALID_LICENSE: 'destroyHasValidLicense',
};
